export default __webpack_public_path__ + "static/media/Users.52360bc5.svg";